import { render, staticRenderFns } from "./ProjectManager.vue?vue&type=template&id=5b205a5f&scoped=true&"
import script from "./ProjectManager.vue?vue&type=script&lang=js&"
export * from "./ProjectManager.vue?vue&type=script&lang=js&"
import style0 from "./ProjectManager.vue?vue&type=style&index=0&id=5b205a5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b205a5f",
  null
  
)

export default component.exports